import gql from "graphql-tag";

export const GIFT_BY_CLIENT = gql`
  query giftByClient($params: GiftByClientParams!) {
    giftByClient(params: $params) {
      error
      message
      code
      data {
        gift {
          _id
          uid
          date
          image
        }
      }
    }
  }
`;


